import { render, staticRenderFns } from "./rewardDiceFreeSpinEdit.vue?vue&type=template&id=32c62e0a&scoped=true&"
import script from "./rewardDiceFreeSpinEdit.vue?vue&type=script&lang=js&"
export * from "./rewardDiceFreeSpinEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c62e0a",
  null
  
)

export default component.exports